import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';

import CourseDetailsHeader from '../../CourseDetailsHeader/CourseDetailsHeader';
import Discussion from '../../../../components/Discussion/Discussion';

@connect(state => ({
  course: state.courseDetails.course,
}))
export default class CourseDetailsDiscussion extends React.Component {
  static contextTypes = {
    query: PropTypes.shape({
      ts: PropTypes.string,
    }),
  };

  render() {
    return (
      <div>
        <CourseDetailsHeader />
        <Discussion ts={_.get(this, 'context.query.ts')} />
      </div>
    );
  }
}
